"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PriceTagOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M28.0013,2h-10a1.9658,1.9658,0,0,0-1.41.59l-14,14a1.9738,1.9738,0,0,0,0,2.82l10,10a1.98,1.98,0,0,0,2.82,0l14-14a1.9661,1.9661,0,0,0,.59-1.41V4A2.0059,2.0059,0,0,0,28.0013,2Zm0,12-14,14-10-10,14-14h10Z"/><circle cx="22.0013" cy="10" r="2"/><path d="M14.6813,17.5029l-1.0372-.2415c-.8957-.2383-1.2953-.6061-1.2953-1.1927,0-.6146.5379-1.0508,1.3287-1.1368a1.9916,1.9916,0,0,1,1.8944.9831.6964.6964,0,0,0,.6533.4232c.355,0,.5759-.1895.5759-.4941a1.1561,1.1561,0,0,0-.0522-.3255,2.5349,2.5349,0,0,0-2.2851-1.5909v-.2611a.6449.6449,0,1,0-1.289,0v.2946A2.3091,2.3091,0,0,0,11.03,16.2256c0,1.1529.7144,1.8561,2.2463,2.2122l1.0184.2422c1.0158.263,1.3934.5931,1.3934,1.2187,0,.6784-.5255,1.118-1.4023,1.1778a2.1337,2.1337,0,0,1-2.0581-.9974.6375.6375,0,0,0-.62-.4323.54.54,0,0,0-.6067.5671,1.0521,1.0521,0,0,0,.06.3248,2.4922,2.4922,0,0,0,2.1174,1.5148v.2849a.6447.6447,0,1,0,1.289,0v-.2541c1.2593-.1341,2.5332-.8121,2.5332-2.3737C17.0013,18.5446,16.3076,17.8844,14.6813,17.5029Z"/>';
var PriceTagOutlineSVG = function PriceTagOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.PriceTagOutlineSVG = PriceTagOutlineSVG;
PriceTagOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(PriceTagOutlineSVG);
exports.default = _default;